export const TEXT = {
  // errors
  MAXIMUM_SEARCHES: 'Sorry, you can only create 5 alerts.',
  EXISTING_USER:
    'We were unable to create your alert because an account with that email ' +
    'already exists. Please sign in to continue.',
  NO_EMAIL: 'Sorry, no email address was found.',
  NOT_VALID_QUERY: 'Sorry, we could not create a valid alert at this time.',
  NOT_VALID_EMAIL:
    'Looks like you have a typo in your email domain. Please check your spelling and try again.',
  CONSUMED: 'This alert has already been created.',
  REFRESH: 'Failed to create alert, please refresh the page and try again.',
  // success
  SUCCESS: 'Alert successfully created.',
  FAIL: 'Could not create alert.',
} as const

export const QUERY_PRICE_DELTA = 0.15
